import { createApp } from 'vue'
import axios from 'axios'

import App from './App.vue'
import router from './router'
import './assets/tailwind.css'

async function initCSRF() {
  try {
    await axios.get('/api/csrf/', { withCredentials: true })
  } catch (error) {
    // The first anonymous render can continue; protected requests handle auth.
  }
}

initCSRF().finally(() => {
  createApp(App).use(router).mount('#app')
})
